/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { Skeleton, SkeletonRow } from '@adobe-commerce/elsie/components';
import '@adobe-commerce/elsie/components/ProductItemCard/ProductItemCardSkeleton.css';

export const ProductItemCardSkeleton: FunctionComponent = () => {
  return (
    <div className="dropin-product-item-card dropin-product-item-card-skeleton">
      <Skeleton className="dropin-product-item-card__skeleton dropin-product-item-card__image-container">
        <SkeletonRow
          fullWidth={true}
          className="dropin-product-item-card__skeleton__image"
        />
      </Skeleton>
      <Skeleton className="dropin-product-item-card__content dropin-product-item-card__skeleton__content">
          <SkeletonRow
            fullWidth={true}
            size="xsmall"
            className="dropin-product-item-card__skeleton__item"
          />
          <SkeletonRow
            fullWidth={true}
            size="xsmall"
            className="dropin-product-item-card__skeleton__item"
          />
          <SkeletonRow
            fullWidth={true}
            size="xsmall"
            className="dropin-product-item-card__skeleton__item"
          />
        </Skeleton>
    </div>
  );
};
